import { UseMutationOptions, useMutation, useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";

/** Add Tenant search: users by name / phone / email with community, property and relationship. */
export const useSearchTenantCandidates = ({ communityId, query }: { communityId: string; query: string }): UseQueryResult<any> =>
  useQuery({
    queryKey: ["tenant-candidates", communityId, query],
    queryFn: () => axiosAuth.get(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/tenant-candidates`, { params: { q: query } }),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId && communityId != "all" && (query?.trim()?.length || 0) >= 2,
  });

interface AddTenantProps {
  communityId: string;
  ownershipId: string;
  data: any; // { userId } or { firstName, lastName, phoneNumber, email } + startDate, endDate
}

/** Attach an existing or new user as TENANT on the title. */
export const useAddTenantMutation = (queryParams?: UseMutationOptions<any, Error, AddTenantProps, unknown>) =>
  useMutation({
    mutationFn: async ({ communityId, ownershipId, data }: AddTenantProps) =>
      await axiosAuth.post(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/${ownershipId}/tenants`, data),
    ...queryParams,
  });
